import { NavState } from '../types';
import { ReduxState } from '../../../../types';

/**
 * @param {ReduxState} state - The Redux state.
 * @returns {NavState} The Stats Leaders state.
 */
export const navSelector = (state) => state.videoHub.nav;
